/* eslint-disable eqeqeq */
import { ISearchedEstimate } from "./CommonProps";
import { StampedService } from "./StampedService";
import { IBodyshopService } from "./UserService";
import { JobEstimationDetail } from "./modals/JobEstimationDetail";
export enum SortType {
  text = 1,
  number = 2,
  date = 3
}
export enum sortOrder {
  asc = "asc",
  desc = "desc"
}
export class Common {
  createCustomerInStamped(
    stampedService: StampedService,
    estimateDetails: JobEstimationDetail,
    ibsService: IBodyshopService,
    showHideLoader: (value: boolean) => void,
    callback: () => void = function () {}
  ) {
    stampedService
      .addOrUpdateCustomer(
        {
          firstName: estimateDetails.firstName,
          lastName: estimateDetails.lastName,
          email: estimateDetails.email
        },
        stampedService.customerId
      )
      .then((res) => {
        stampedService.currentCustomerPoints = res.points;
        stampedService.referralCode = res.referralCode;
        stampedService.referralUrl = res.referralUrl;
        if (!res.isSubscribed) {
          stampedService.subscribeCustomer(res.email).then((res1) => {
            // stampedService.subscribeCustomer(res.email).then(res1 => {
            ibsService
              .updateReferenceNumber(
                estimateDetails.estimateId,
                res.referralCode
              )
              .then((res) => {
                showHideLoader(false);
                if (callback) callback();
              });
            // });
            // ibsService.updateReferenceNumber(estimateDetails.estimateId, res.referralCode).then(res => {
            //     showHideLoader(false);
            //     if (callback)
            //         callback();
            // });
          });
        } else {
          ibsService
            .updateReferenceNumber(estimateDetails.estimateId, res.referralCode)
            .then((res) => {
              showHideLoader(false);
              if (callback) callback();
            });
        }
      });
  }

  isAuthorityRequested(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return isLinkOpenedFromEmail
      ? true
      : estimateDetails &&
          estimateDetails.canAuthorise &&
          estimateDetails.canCancelAuthorityRequest; // && estimateDetails.header.jobBooking != null;
  }

  isEstimateScreenActionRequired(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return (
      (isLinkOpenedFromEmail
        ? estimateDetails
          ? estimateDetails.authorisationOutcome == "NotAuthorised"
          : false
        : estimateDetails
        ? estimateDetails.authorisationOutcome == "NotAuthorised" &&
          this.isAuthorityRequested(estimateDetails, isLinkOpenedFromEmail)
        : false) && !this.isEstimateDeclined(estimateDetails)
    );
  }

  isBookingScreenActionRequired(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return (
      estimateDetails.jobNumber == 0 &&
      !this.isEstimateScreenActionRequired(
        estimateDetails,
        isLinkOpenedFromEmail
      )
    );
  }

  isRepairTrackerActionRequired(
    estimateDetails: JobEstimationDetail,
    status: string,
    isLinkOpenedFromEmail: boolean
  ) {
    return (
      estimateDetails &&
      estimateDetails.jobIssuedDate != null &&
      !this.isBookingScreenActionRequired(
        estimateDetails,
        isLinkOpenedFromEmail
      ) &&
      (status != "Ready for Pickup" || !estimateDetails.isVehicleCollected)
    );
  }
  isEstimateFeedbackRequired(
    status: string,
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return estimateDetails?.isVehicleCollected;
    // status == "Ready for Pickup" && estimateDetails.header.isJobCompleted;
  }
  isEstimateDeclined(estimateDetails: JobEstimationDetail) {
    return estimateDetails && estimateDetails.isCancelled;
  }
  getEstimateStatus(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    if (estimateDetails) {
      if (estimateDetails.isCancelled) {
        return estimateDetails.cancellationReason == "Decline Estimate"
          ? "Rejected"
          : estimateDetails.cancellationReason;
      } else if (
        this.isEstimateScreenActionRequired(
          estimateDetails,
          isLinkOpenedFromEmail
        ) ||
        (estimateDetails.canAuthorise && !estimateDetails.canCancelAuthority)
      ) {
        return "Pending";
      } else {
        return "Accepted";
      }
    }
    return "";
  }
  getReferalStatus(item: ISearchedEstimate) {
    return item.isVehicleCollected
      ? "Completed"
      : item.isVehicleOnsite
      ? "Pending"
      : item.cancelled
      ? "Rejected"
      : "Pending";
  }
  private isValueExist(obj: any, key: string, subKey: string) {
    return subKey
      ? obj[key] && obj[key][subKey] && obj[key][subKey] != ""
      : obj[key] && obj[key] != "";
  }
  private getValue(obj: any, key: string, subKey: string) {
    return subKey ? obj[key][subKey] : obj[key];
  }
  public getSortedDataWithKey(
    arr: any[],
    key: string,
    order: sortOrder,
    sortType: SortType,
    subKey: string = ""
  ) {
    let isValueExist = this.isValueExist;
    if (!sortType) {
      sortType = SortType.text;
    }
    var sortdata = arr.sort((a, b) => {
      var x = a[key];
      var y = b[key];
      if (subKey) {
        x = a[key][subKey];
        y = b[key][subKey];
      }
      switch (sortType) {
        case SortType.text:
          x = isValueExist(a, key, subKey)
            ? this.getValue(a, key, subKey).toString().toLowerCase()
            : "";
          y = isValueExist(b, key, subKey)
            ? this.getValue(b, key, subKey).toString().toLowerCase()
            : "";
          break;
        case SortType.date:
          x = isValueExist(a, key, subKey)
            ? new Date(this.getValue(a, key, subKey))
            : null;
          y = isValueExist(b, key, subKey)
            ? new Date(this.getValue(b, key, subKey))
            : null;
          break;
        case SortType.number:
          x = isValueExist(a, key, subKey)
            ? Number(this.getValue(a, key, subKey))
            : null;
          y = isValueExist(b, key, subKey)
            ? Number(this.getValue(b, key, subKey))
            : null;
          break;
      }

      if (order == "asc") {
        if (x < y) return -1;
        if (x > y) return 1;
      } else if (order == "desc") {
        if (x > y) return -1;
        if (x < y) return 1;
      }
      return 0;
    });

    return sortdata;
  }

  public showEstimateAmount(debtorName: string) {
    var configArray: any = {
      Private: true,
      "AUTO & GENERAL SERVICES PTY LTD": false,
      Rework: false
    };
    return configArray[debtorName] != false ? true : false;
  }
}
